import { Box, Button, Grid, Typography, useTheme } from "@material-ui/core";
import { assetIds, ThemedAsset } from "nemuru-components";
import React, { useContext } from "react";
import { ICON_TITLE_HEIGHT, Program } from "../../../../../../../config/config";
import { ProcessContext } from "../../../../../../../contexts/ProcessContext";
import IconTitle from "../../../../../../shared/components/IconTitle";
import MainButton from "../../../../../../shared/components/MainButton";
import Text from "../../../../../../shared/components/Text";
import { ONBOARDING_PARTICIPANT_ROLES } from "../../../../../../shared/config";
import { LOAN_SUMMARY_AND_ADJUST_STEP_NAMES } from "../../../config";
import {
  AdjustLoanSlider,
  THEMES_TO_ENABLE_QUOTA_SELECTION,
} from "./components/AdjustLoanSlider";
import { isOnboardingByBorrower } from "../../../../../../../utils/isOnboardingByBorrower";
import { THEME_NAMES } from "../../../../../../../config/themes/config";
import { ConfigContext } from "../../../../../../../contexts/ConfigContext";
import { AvailableLenders } from "../../../../../quotaAdjustment/components/AvailableLenders";
import { AuthContext } from "../../../../../../../contexts/AuthContext";

const NON_ALLOWED_THEMES_FOR_ADDING_CO_BORROWER = [THEME_NAMES.ktuin];

export function SummaryAndAdjustWrapper({
  termMarks,
  minTerm,
  maxTerm,
  handleRequestLoanOrShowOptinsDialog,
  getValues,
  loanConditions,
  setModuleStepGroup,
  handleLoanTermSlider,
  ConditionsComponent,
  hasMultiplePricings,
  availableLenders,
  allLenders,
}) {
  const {
    state: { loan, flowLoading, participant },
  } = useContext(ProcessContext);
  const {
    state: { themeName },
  } = useContext(ConfigContext);
  const {
    state: { agent },
  } = useContext(AuthContext);

  const { palette, customBorderRadius } = useTheme();

  const onBoardingByBorrower = isOnboardingByBorrower(
    participant.onboardingFulfilledBy
  );

  const hasLoanCoBorrower = loan?.onboarding_details.some(
    (participant) =>
      participant.role === ONBOARDING_PARTICIPANT_ROLES.CO_BORROWER
  );

  const quotaSelectionEnabled =
    agent.quota_selection_by_borrower_is_allowed &&
    THEMES_TO_ENABLE_QUOTA_SELECTION.includes(agent.custom_theme);

  const programName = loan.loan_conditions?.program.name;
  const isParticipantAdditionAllowedForLoan =
    participant.role === ONBOARDING_PARTICIPANT_ROLES.BORROWER &&
    !NON_ALLOWED_THEMES_FOR_ADDING_CO_BORROWER.includes(themeName);

  return (
    <>
      <Box
        className="appear-anim"
        style={{
          display: flowLoading.show ? "none" : "block",
        }}
      >
        <IconTitle
          icon={
            <ThemedAsset
              id={assetIds.ICON_LOAN_ADJUST}
              width={ICON_TITLE_HEIGHT}
              height={ICON_TITLE_HEIGHT}
              style={{ color: palette.secondary.main }}
            />
          }
          title={<Text tId={"GOOD"} />}
          subtitle={<Text tId="YOUR_LOAN_RESULT" />}
        />
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          className="appear-anim"
        >
          {programName === Program.NO_PURCHASE ? (
            <Box mt={1} />
          ) : (
            <AdjustLoanSlider
              termMarks={termMarks}
              minTerm={minTerm}
              maxTerm={maxTerm}
              loanConditions={loanConditions}
              handleLoanTermSlider={handleLoanTermSlider}
              onBoardingByBorrower={onBoardingByBorrower}
              hasMultiplePricings={hasMultiplePricings}
            />
          )}
        </Box>
        <Box mt={2} />
        {themeName !== THEME_NAMES.caixabank &&
          availableLenders &&
          allLenders && (
            <AvailableLenders
              availableLenders={availableLenders}
              allLenders={quotaSelectionEnabled ? allLenders : availableLenders}
            />
          )}
        <Box
          p={3}
          m={1}
          borderRadius={customBorderRadius.paper}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          bgcolor={palette.dark.main}
          color={palette.dark.contrastText}
          style={{
            maxHeight: "200px",
          }}
        >
          <Grid
            container
            display="flex"
            alignItems="center"
            justifyContent="space-around"
            spacing={2}
          >
            {ConditionsComponent}
          </Grid>
        </Box>
      </Box>
      <Box />
      <Box>
        <Box display={"flex"} flexDirection={"row"} gridGap={8}>
          <i
            className="material-icons-outlined"
            style={{
              fontSize: 14,
              paddingTop: "2px",
              marginLeft: "6px",
              color: palette.warning.main,
            }}
          >
            info
          </i>
          <Typography variant="caption" color="textSecondary">
            <Text tId="APPLY_FOR_LOAN_BODY" />
          </Typography>
        </Box>
        {!hasLoanCoBorrower &&
          isParticipantAdditionAllowedForLoan &&
          setModuleStepGroup && (
            <Button
              style={{ marginTop: "24px", marginBottom: "-8px", height: 48 }}
              fullWidth
              variant={"contained"}
              color={"secondary"}
              onClick={() =>
                setModuleStepGroup(
                  LOAN_SUMMARY_AND_ADJUST_STEP_NAMES.ADD_CO_BORROWER_TO_LOAN
                )
              }
            >
              <Text tId={"ADD_CO_BORROWER"} />
            </Button>
          )}
        <MainButton
          onClick={() => handleRequestLoanOrShowOptinsDialog(getValues())}
        >
          <Text tId="APPLY_FOR_LOAN" />
        </MainButton>
      </Box>
    </>
  );
}
